import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {Outlet, useNavigate} from 'react-router-dom'
import { getUser } from '../Redux/loginUserSlice'
const AuthLayout = () => {
  const dispatch = useDispatch()
  const user = localStorage.getItem('User')
  dispatch(getUser(user))
  const navigate = useNavigate()

  useEffect(()=>{
if(user){
  navigate('/')
}
  }, [navigate, user])

  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default AuthLayout
